import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";

// Core pages loaded immediately for fast navigation
import { HomePage } from "@/pages/HomePage";
import { MethodologyPage } from "@/pages/MethodologyPage";
import { LeadershipPage } from "@/pages/LeadershipPage";
import { TechnicalPillarsPage } from "@/pages/TechnicalPillarsPage";
import { ServicePillarsPage } from "@/pages/ServicePillarsPage";
import { AboutPage } from "@/pages/AboutPage";
import { ContactPage } from "@/pages/ContactPage";
import { CareersPage } from "@/pages/CareersPage";
import { ResourcesPage } from "@/pages/ResourcesPage";
import { IVAPage } from "@/pages/IVAPage";
import { GrantWritingPage } from "@/pages/GrantWritingPage";
import { LeadershipAcademyEnrollPage } from "@/pages/LeadershipAcademyEnrollPage";
import { PrivacyPolicyPage } from "@/pages/PrivacyPolicyPage";
import { TermsOfServicePage } from "@/pages/TermsOfServicePage";
import { StaffPortalPage } from "@/pages/StaffPortalPage";
import { EducationPage } from "@/pages/EducationPage";

// Admin pages lazy loaded (less frequently accessed)
const AdminLoginPage = lazy(() => import("@/pages/AdminLoginPage").then(m => ({ default: m.AdminLoginPage })));
const AdminDashboardPage = lazy(() => import("@/pages/AdminDashboardPage").then(m => ({ default: m.AdminDashboardPage })));

// Loading fallback component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50">
    <div className="w-10 h-10 border-2 border-teal-600 border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App" data-testid="app">
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Admin Routes (without Layout) */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            
            {/* Public Routes (with Layout) */}
            <Route path="/*" element={
              <Layout>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/methodology" element={<MethodologyPage />} />
                  <Route path="/leadership" element={<LeadershipPage />} />
                  <Route path="/technical-pillars" element={<TechnicalPillarsPage />} />
                  <Route path="/services" element={<ServicePillarsPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/careers" element={<CareersPage />} />
                  <Route path="/resources" element={<ResourcesPage />} />
                  <Route path="/iva" element={<IVAPage />} />
                  <Route path="/grant-writing" element={<GrantWritingPage />} />
                  <Route path="/leadership-academy/enroll" element={<LeadershipAcademyEnrollPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/privacy" element={<PrivacyPolicyPage />} />
                  <Route path="/terms" element={<TermsOfServicePage />} />
                  <Route path="/staff" element={<StaffPortalPage />} />
                  <Route path="/education" element={<EducationPage />} />
                </Routes>
              </Layout>
            } />
          </Routes>
        </Suspense>
        <Toaster 
          position="top-right" 
          richColors 
          theme="dark"
          toastOptions={{
            style: {
              background: '#0F172A',
              border: '1px solid #1E293B',
              color: '#F8FAFC',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
